module.exports = __webpack_public_path__ + "img/23.8dc7bd8d.png";